export type { BrandConfig } from './types';

export { neutralBrand } from './neutral';
export { tagadapay } from './tagadapay';

// Client brand registry: TagadaPay + the white-label brand of this deploy, if
// any. Partner-mode brand files (suby, payoren, ...) are NOT registered here:
// they are server / edge only (`../partner-injection.ts`) and reach the SPA
// through the middleware-injected partner context (`../current-partner.ts`).
import { tagadapay } from './tagadapay';
import { whitelabelBrands } from './whitelabel';
import type { BrandConfig } from './types';

export const brands: Record<string, BrandConfig> = {
  tagadapay,
  ...whitelabelBrands,
};

export type BrandName = keyof typeof brands;
